import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ChartLine"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.5025 21L8.295 12L13.77 16.8675C14.1174 17.1762 14.5883 17.3064 15.045 17.22C15.5059 17.1337 15.9 16.8368 16.11 16.4175L20.25 8.175L18.885 7.5L14.7675 15.75L9.2925 10.8825C8.9539 10.5676 8.48901 10.4265 8.0325 10.5C7.58181 10.5748 7.18976 10.8509 6.9675 11.25L3 18.75V1.5H1.5V21C1.5 21.8284 2.17157 22.5 3 22.5H22.5V21H3.5025Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ChartLine.vue"]]);
